<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">LPS Points Spent</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      / <b>Loyalty Point System</b> /
      <b>LPS Points Spent</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="card mb-4">
      <div class="card-body">
        <h4 class="card-title mb-3">
          <b>Report</b>
        </h4>

        <div class="form-group">
          <div class="row mb-4">
            <div class="col-2">
              <select class="form-control" v-model="filter_year">
                <option v-for="(year, index) in years" :key="index">{{
                  year
                }}</option>
              </select>
            </div>
            <div class="col-2">
              <button id="btnFilter" class="btn btn-primary mr-2" @click="applyFilter()">
                Filter
              </button>

              <button id="btnAll" class="btn btn-primary d-none" @click="removeFilter()">
                Reset
              </button>
            </div>
          </div>
        </div>

        <!-- <div class="card-title">
          <button class="btn btn-primary" @click="print">Print</button>
        </div> -->

        <div id="printGraph">
          <h4 class="text-center">
            <b>{{ title }}</b>
          </h4>

          <GChart
            type="ColumnChart"
            :data="chart"
            :options="options"
          />
        </div>
      </div>
    </div>

    <!-- Table Data -->
    <div class="card mb-4">
      <div class="card-body">
        <h4 class="card-title mb-3">
          <b>LPS Points Spent</b>
        </h4>

        <div class="table-responsive">
          <table
            id="active_tbl"
            class="display table table-striped table-bordered"
            style="width:100%; text-align: center;"
          >
            <thead>
              <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Total Points</th>
                <th>Points Type</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in tableData" :key="index">
                <td>{{ data.year }}</td>
                <td>{{ data.month_name }}</td>
                <td>{{ data.total_points }}</td>
                <td>{{ data.points_type }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
  ></loading>
  </div>

</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    GChart,
    Loading,
  },

  data() {
    return {
      token: null,
      year: 0,
      years: [],
      filter_year: "",

      tableData: [],

      title: null,
      chart: [],
      options: {},

      isLoading: false,
      fullPage: true,

    };
  },

  methods: {
    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    loadToken() {
      let token = localStorage.getItem("token");

      if (token !== null) {
        token = JSON.parse(token);
        this.token = token.access_token;
      }
    },

    loadData() {
      let year = "";

      if (this.filter_year.length != 0) {
        year = "?year=" + this.filter_year;
        this.year = this.filter_year;
      }

      axios
        .get(axios.lpsURL + "/reports/points/spent" + year, {
          headers: {
            Authorization: "Bearer " + this.token
          }
        })
        .then(res => {
          this.tableData = res.data.data;
        })
        .then(() => {
          this.createDatatable();
        });
    },

    loadChart() {
      let year = "";

      if (this.filter_year.length != 0) {
        year = "?year=" + this.filter_year;
        this.year = this.filter_year;
      }

      this.isLoading = true;

      axios
        .get(axios.lpsURL + "/reports/points/spent/chart" + year, {
          headers: {
            Authorization: "Bearer " + this.token
          }
        })
        .then(res => {
          this.chart = res.data.chart;
          this.title = res.data.title;
          this.options = res.data.options;
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.years = [];

      this.loadYearFilter();
      this.destroyDatatable()
      this.loadData()
      this.loadChart()
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      this.destroyDatatable()
      this.loadData()
      this.loadChart()
    },

    createDatatable() {
      $("#active_tbl").DataTable({
        dom: "Bfrtip",
        pageLength: 5,
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          },
        ]
      });
    },

    destroyDatatable() {
      $("#active_tbl")
        .DataTable()
        .destroy();
    },
  },

  async created() {
    this.loadToken();
    this.loadYearFilter();
    this.loadData();
    this.loadChart();
  }
};
</script>
